import { KdsTicket } from '../types/ticket';

export const filterByConsumptionModes = (tickets: KdsTicket[], consumptionModes: string[]): KdsTicket[] =>
    tickets.filter(({ consumptionMode }) => consumptionModes.includes(consumptionMode));
